import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import api from "../../utils/api";

function SalaryStructure() {
  const [salaryStructure, setSalaryStructure] = useState({});
  const { empid } = useParams();

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get(`/salaryStructure/${empid}`);
        console.log("Fetched payslips:", response.data); // Log the fetched data
        setSalaryStructure(response.data);
      } catch (error) {
        console.error("Error fetching employees:", error);
        setSalaryStructure([]); // Set empty array on error
      }
    };

    fetchEmployees();
  }, []);

  return (
    <div className="w-full h-full">
      <div className="p-5 mb-10">
        <h1 className="text-2xl text-start font-bold">Salary Structure</h1>
      </div>

      <form className="flex justify-evenly items-center">
        <div className="flex flex-col w-80">
          <label className="text-sm font-semibold text-gray-700 mb-4">
            Basic salary
          </label>
          <input
            type="text"
            name="name"
            placeholder="BASIC SALARY"
            className="border shadow pl-4 pr-2 py-2 w-full rounded-full mb-5"
            value={salaryStructure.basicDa}
            id="name"
          />

          <label className="text-sm font-semibold text-gray-700 mb-4">
            HRA
          </label>
          <input
            type="text"
            name="name"
            placeholder="HRA"
            className="border shadow pl-4 pr-2 py-2 w-full rounded-full mb-5"
            value={salaryStructure.hra}
            id="name"
          />

          <label className="text-sm font-semibold text-gray-700 mb-4">
            SP.AL
          </label>
          <input
            type="text"
            name="name"
            placeholder="SP.AL"
            className="border shadow pl-4 pr-2 py-2 w-full rounded-full mb-5"
            value={salaryStructure.sp_al}
            id="name"
          />

          <label className="text-sm font-semibold text-gray-700 mb-4">
            GROSS
          </label>
          <input
            type="text"
            name="name"
            placeholder="GROSS"
            className="border shadow pl-4 pr-2 py-2 w-full rounded-full mb-5"
            value={salaryStructure.gross}
            id="name"
          />

          {/* <button className="bg-slate-800 text-white pl-4 pr-2 py-2 w-full rounded-full text-lg hover:bg-slate-300 disabled:opacity-80">
            Save Salary Structure
          </button> */}
        </div>
      </form>
    </div>
  );
}

export default SalaryStructure;
